import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

import { RouterProvider } from 'react-router-dom';
import router from './Router';
import { store } from './store/store';
import { Provider } from 'react-redux';
import AppToastContainer from './components/shared/AppToastContainer';


function App() {
  return <Provider store={store}>
    <RouterProvider router={router} />
    <AppToastContainer />
  </Provider>
}

export default App;
